import { apiCall } from "./_utils";
import { apiUrls } from "./_constants";

export const appService = {
  getPermissions,
  getUser
};

function getPermissions() {
  return apiCall("GET", apiUrls.getUser.permissions);
}

function getUser() {
  return apiCall("GET", apiUrls.getUser.user);
}
